import * as React from 'react';
import { Checkbox } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const CheckboxGroup = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <Checkbox.Group {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default CheckboxGroup;
